function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.005 14.176A3 3 0 006 17h2.003c.007-.114.025-.23.054-.347L8.22 16H6l-.15-.005A2 2 0 014 14v-4h3l.176-.005A3 3 0 0010 7V4h4l.15.005A2 2 0 0116 6v2.003a2.88 2.88 0 011 .13V6l-.005-.176A3 3 0 0014 3H9.621l-.176.008a2 2 0 00-1.238.578L3.586 8.207l-.12.13A2 2 0 003 9.62V14l.005.176zM7 9l-2.782-.001c.023-.03.048-.058.075-.085l4.621-4.621L9 4.219V7l-.005.15A2 2 0 017 9zm2.98 5.377l4.83-4.83a1.87 1.87 0 112.644 2.646l-4.83 4.829a2.197 2.197 0 01-1.02.578l-1.498.374a.89.89 0 01-1.079-1.078l.375-1.498c.096-.386.296-.74.578-1.02z"
});

function SvgResetDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgResetDefault;